import { render, staticRenderFns } from "./GridMap.vue?vue&type=template&id=10cdbc26&scoped=true&"
var script = {}
import style0 from "./GridMap.vue?vue&type=style&index=0&id=10cdbc26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cdbc26",
  null
  
)

export default component.exports